import api from '@api';
import Config from '@config';

const formatApiImage = (image: any) => ({
    src: Config.templateFilesUrl + image.PATH,
    type: 'image',
    api_ID: image.ID,
    api_ID_FILE: image.ID_FILE,
    name: image.ORIGINAL_FILE_NAME,
});

const getApiImages = () => {
    return new Promise((resolve: any) => {
        return api('get', `api/secure/files/public/emailImages`).then((response: any) => {
            resolve(response.data.data.map((image: any) => formatApiImage(image)));
        });
    });
};

export const getImages = async () => {
    return await Promise.allSettled([getApiImages()]).then((data): any => {
        return [].concat(...data.map((item: any): any => item.value));
    });
};
export const uploadImages = async (files: any, callback: any) => {
    callback(
        await Promise.all(
            files.map((file: any) => {
                return new Promise((resolve: any) => {
                    api('POST', `api/secure/files/public`, {
                        body: file.src,
                        fileName: file.name,
                        type: 'emailImages',
                    }).then((response: any) => {
                        resolve(formatApiImage(response.data.data));
                    });
                });
            })
        )
    );
};
export const removeImage = (id: number) => {
    api('PUT', `api/secure/files/public/${id}/deactivate`, {}).then((response: any) => {});
};

export const getInitVersion = (emailTemplateData: any, data: any, versionData: any) => {
    const newVersions = emailTemplateData?.TEMPLATE?.versions || [];
    const oldVersions = data?.TEMPLATE?.versions || [];

    // new version
    if (oldVersions.length && newVersions.length && newVersions.length > oldVersions.length) {
        const newVersion = newVersions?.find(
            (newVersion: any) => !oldVersions.find((oldVersion: any) => oldVersion.id === newVersion.id)
        );
        if (newVersion) {
            return newVersion;
        }
    }

    // select version
    if (versionData.id) {
        const selectedVersion = newVersions?.find((newVersion: any) => newVersion.id === versionData.id);
        if (selectedVersion) {
            return selectedVersion;
        }
    }

    // ative version
    const activeVersion = newVersions?.find((newVersion: any) => newVersion.active);
    if (activeVersion) {
        return activeVersion;
    }

    // first verson
    return newVersions[0];
};
